import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import { BodyCopy } from 'components/ui/Typography'

import s from './List.module.scss'
const cn = classNames.bind(s)

const ListItem = ({ text }) => (
  <li className={cn('item')}>
    <BodyCopy>{text}</BodyCopy>
  </li>
)

ListItem.propTypes = {
  text: PropTypes.string,
}

export default ListItem
